import React from 'react'
import type { SvgIconProps } from '@material-ui/core/SvgIcon'
import SvgIcon from '@material-ui/core/SvgIcon'

const LightningIcon = (props: SvgIconProps) => (
  <SvgIcon width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5.60352 0.602875C5.79953 0.309065 6.17062 0.184989 6.50391 0.301117C6.83775 0.417772 7.04983 0.745748 7.02051 1.09799L6.60059 6.13705L6.57812 6.40854H9.32324C9.60478 6.40854 9.86427 6.56093 10.001 6.80698C10.1375 7.05369 10.1299 7.35521 9.98047 7.59409L4.85547 15.7943C4.71095 16.0251 4.45969 16.1576 4.19824 16.1576C4.15797 16.1575 4.11745 16.1552 4.07715 16.1488L3.95703 16.1195L3.83496 16.0677C3.56633 15.9253 3.40178 15.6347 3.42578 15.3236L3.85352 9.76498L3.87402 9.49545H1.12402C0.838019 9.49545 0.575075 9.33814 0.44043 9.08627L0.396484 8.98959C0.311128 8.75899 0.3398 8.49844 0.478516 8.29037L5.60352 0.602875Z"
      fill="#394860"
      stroke="white"
      strokeWidth="0.5"
    />
  </SvgIcon>
)
export default LightningIcon
